/**
 * Builds a shareable URL, preserving any existing URL parameters while adding
 * slug and node parameters as needed.
 *
 * @param baseUrl - The base URL to use (usually current location)
 * @param slugParam - Optional slug parameter for content identification
 * @param nodeIndex - Optional node index for deep-linking
 * @returns The formatted share URL with all parameters preserved
 */
export const buildShareUrl = (
  baseUrl: string,
  slugParam?: string | null,
  nodeIndex?: number | null
): string => {
  const url = new URL(baseUrl);
  
  // Ensure slugParam is set if provided and not already present
  if (slugParam && !url.searchParams.has('s')) {
    url.searchParams.set('s', slugParam);
  }
  
  // Set (or override) node index param if provided
  if (nodeIndex !== undefined && nodeIndex !== null) {
    url.searchParams.set('n', String(nodeIndex));
  }
  
  // All other URL parameters are automatically preserved since we're using the URL object
  return url.toString();
};
